import { observer } from 'mobx-react-lite';
import { useComputed } from 'owa-react-hooks/lib/useComputed';
import { mailEllipsisAriaLabelText } from 'owa-locstrings/lib/strings/mailellipsisarialabeltext.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableMenuItem } from 'owa-filterable-menu';
import { FilterableCommandBar } from 'owa-filterable-menu';
import { TabViewState, lazyCloseTab } from 'owa-tab-store';

export interface SecondaryReadingPaneTabCommandingBarProps {
    tab: TabViewState;
}

export default observer(function SecondaryReadingPaneTabCommandingBar(
    props: SecondaryReadingPaneTabCommandingBarProps
) {
    const closeMenuItem = useComputed(
        (): FilterableMenuItem => {
            const { tab } = props;
            return new FilterableMenuItem(
                null,
                ControlIcons.Cancel,
                () => {
                    lazyCloseTab.importAndExecute(tab);
                },
                () => true /*shouldShow*/,
                DisplayOption.Right
            );
        }
    );
    return (
        <FilterableCommandBar
            filterableItems={[closeMenuItem.get()]}
            elipisisAriaLabel={loc(mailEllipsisAriaLabelText)}
        />
    );
});
